import React, { useMemo } from "react";
import { Controller, useFormState } from "react-hook-form";
import "stylesheets/comman/inputBox.scss";

const SelectBox = (props) => {
  const {
    control,
    name = "",
    label,
    selectList = [],
    onChange,           // <-- let parent listen
    selectDocuments,    // legacy callback (keep if you still use it)
    grouClass,          // (typo from your code; keeping same name)
    ...rest
  } = props;

  const state = useFormState({ control, name });
  const isErrorExist = useMemo(() => Boolean(state.errors?.[name]), [state.errors, name]);
  const errorMessage = useMemo(() => state.errors?.[name]?.message, [state.errors, name]);

  // normalize label text for each option
  const getLabel = (item) => item.name ?? item.label ?? item.value ?? String(item);

  if (control === undefined) {
    // uncontrolled fallback
    return (
      <div className="form-group">
        {label && <label className="title">{label}</label>}
        <div className="position-relative">
          <select className="form-control custom-select" {...rest}>
            {selectList.map((item) => (
              <option key={item.id ?? item.value} value={item.value}>
                {getLabel(item)}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div className={`form-group ${grouClass ?? ""}`}>
          {label && <label className="title">{label}</label>}
          <div className="position-relative">
            <select
              {...rest}
              className={`form-control custom-select ${isErrorExist ? "form-control--error" : ""}`}
              name={field.name}
              value={field.value ?? ""}         // controlled value
              onBlur={field.onBlur}
              ref={field.ref}
              onChange={(e) => {
                const v = e.target.value;
                field.onChange(v);               // ✅ update RHF
                onChange?.(v);                   // ✅ notify parent (InlineEditor)
                selectDocuments?.(v);            // optional legacy callback
              }}
            >
              {/* Placeholder when empty */}
              <option value="" disabled>
                Select...
              </option>

              {/* DO NOT use `selected` on options in a controlled select */}
              {selectList.map((item) => (
                <option key={item.id ?? item.value} value={item.value}>
                  {getLabel(item)}
                </option>
              ))}
            </select>
          </div>

          {isErrorExist && <span className="error">{errorMessage}</span>}
        </div>
      )}
    />
  );
};

export default SelectBox;


//previous selectBox


// import React, { useMemo } from "react";
// import { Controller, useFormState } from "react-hook-form";
// import { useMatch } from "react-router-dom";
// import 'stylesheets/comman/inputBox.scss';

// const SelectBox = (props) => {
//   const { control, name = "", required } = props
//   const state = useFormState({ control, name })
//   const isErrorExist = useMemo(() => Boolean(state.errors[name]), [state])
//   const errorMessage = useMemo(() => state.errors[name]?.message || undefined, [state])
//   return (
//     <>
//       {control !== undefined ? (
//         <Controller
//           control={control}
//           name={name}
//           render={({ field }) => (
//             <div className={`form-group ${props.grouClass}`}>
//               {props.label && <label className="title">{props.label}</label>}
//               <div className="position-relative ">
//                 <select className={`form-control custom-select ${isErrorExist ? 'form-control--error' : ''}`} onChange={(event) => {
//                   field.onChange(event.target.value);
//                   if (props.selectDocuments) props.selectDocuments(event.target.value);
//                 }}
//                   value={field.value}>
//                   {props.selected ?
//                     <option value={0} selected>{props.selected}</option> : ''
//                   }
//                   {props?.selectList?.map(item => (
//                     <option key={item.id} value={item.value}>{item.name || item.value}</option>
//                   ))}
//                 </select>
//               </div>
//               {isErrorExist && <span className='error'>{errorMessage}</span>}
//             </div>
//           )}
//         />
//       ) : (
//         <div className="form-group">
//           {props.label && <label className="title">{props.label}</label>}
//           <div className="position-relative">
//               <select className="form-control custom-select">
//               {props.selectList.map(item => (
//                 <option key={item.id} value={item.value}>{item.value}</option>
//               ))}
//             </select>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };
// export default SelectBox;

